import { alpha, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(3),
    width: '100%',
    padding: '0.05px',
    position: 'relative',
    overflow: 'visible',
  },
  button: {
    width: '100%',
    marginTop: '10px',
    marginRight: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      width: 'auto',
      marginTop: 0,
    },
  },
  buttonGroup: {
    width: '100%',
    right: theme.spacing(2),
    top: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      width: 'auto',
      position: 'absolute',
    },
  },
  formHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  formActionShell: {
    display: 'flex',
    gap: theme.spacing(1),
    padding: theme.spacing(0.75),
    borderRadius: 999,
    border: '1px solid rgba(148, 163, 184, 0.18)',
    background:
      'linear-gradient(135deg, rgba(255,255,255,0.92) 0%, rgba(248,250,252,0.88) 100%)',
    boxShadow: '0 12px 28px rgba(15, 23, 42, 0.08)',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flexWrap: 'wrap',
    },
  },
  headerSecondaryButton: {
    minHeight: 44,
    marginTop: '0 !important',
    marginRight: '0 !important',
    padding: theme.spacing(0, 2),
    borderRadius: 999,
    textTransform: 'none',
    fontWeight: 700,
    borderColor: 'rgba(148, 163, 184, 0.28)',
    color: '#334155',
    backgroundColor: 'rgba(255,255,255,0.72)',
    '&:hover': {
      borderColor: 'rgba(37, 99, 235, 0.3)',
      backgroundColor: '#ffffff',
    },
    [theme.breakpoints.down('sm')]: {
      flex: 1,
      width: '100%',
    },
  },
  headerPrimaryButton: {
    minHeight: 44,
    marginTop: '0 !important',
    marginRight: '0 !important',
    padding: theme.spacing(0, 2.5),
    borderRadius: 999,
    textTransform: 'none',
    fontWeight: 700,
    background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 52%, #60a5fa 100%)',
    boxShadow: '0 14px 30px rgba(37, 99, 235, 0.28)',
    '&:hover': {
      background: 'linear-gradient(135deg, #1d4ed8 0%, #2563eb 52%, #3b82f6 100%)',
      boxShadow: '0 16px 32px rgba(37, 99, 235, 0.34)',
    },
    [theme.breakpoints.down('sm')]: {
      flex: 1,
      width: '100%',
    },
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  activity: {
    padding: theme.spacing(2),
  },
  tabSection: {
    padding: theme.spacing(1),
    borderRadius: 20,
    overflow: 'hidden',
    border: `1px solid ${alpha('#7c3aed', 0.12)}`,
    background:
      'linear-gradient(135deg, rgba(255,255,255,0.96) 0%, rgba(248,250,252,0.9) 100%)',
    boxShadow: '0 14px 32px rgba(15, 23, 42, 0.07)',
  },
  tabLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    width: '100%',
  },
  tabIcon: {
    display: 'grid',
    placeItems: 'center',
    width: 28,
    height: 28,
    borderRadius: 10,
    color: '#475569',
    backgroundColor: 'rgba(148, 163, 184, 0.14)',
    transition: 'all 180ms ease',
  },
  tabTextGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    lineHeight: 1.15,
  },
  tabText: {
    fontSize: '0.92rem',
    fontWeight: 700,
    letterSpacing: 0,
  },
  tabHint: {
    fontSize: '0.72rem',
    color: '#64748b',
  },
  tabCount: {
    marginLeft: 'auto',
    minWidth: 28,
    height: 28,
    padding: theme.spacing(0, 1),
    borderRadius: 999,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(99, 102, 241, 0.08)',
    color: '#4338ca',
    fontSize: '0.8rem',
    fontWeight: 700,
    transition: 'all 180ms ease',
  },
  completedDateInput: {
    marginLeft: theme.spacing(1),
  },
  assignee: {
    width: '100%',
  },
  status: {
    width: '100%',
  },
  tab: {
    minHeight: 0,
    '& .MuiTabs-scroller': {
      paddingBottom: theme.spacing(0.5),
      paddingTop: theme.spacing(0.5),
    },
    '& .MuiTabs-flexContainer': {
      gap: theme.spacing(1),
    },
    '& .MuiTabs-indicator': {
      display: 'none',
    },
    '& .MuiTab-root': {
      minHeight: 64,
      minWidth: 160,
      padding: theme.spacing(1.25, 1.5),
      borderRadius: 16,
      overflow: 'hidden',
      border: '1px solid rgba(148, 163, 184, 0.18)',
      backgroundColor: 'rgba(255,255,255,0.72)',
      textTransform: 'none',
      color: '#475569',
      boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.55), 0 2px 6px rgba(15, 23, 42, 0.03)',
      transition:
        'transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease, background-color 180ms ease',
      '&:hover': {
        backgroundColor: '#ffffff',
        borderColor: 'rgba(59, 130, 246, 0.22)',
        // boxShadow:
        //   '0 8px 18px rgba(148, 163, 184, 0.14), 0 2px 6px rgba(59, 130, 246, 0.08)',
        transform: 'translateY(-1px)',
      },
    },
    '& .MuiTab-root.Mui-selected': {
      color: '#0f172a',
      borderColor: 'rgba(37, 99, 235, 0.48)',
      background:
        'linear-gradient(135deg, rgba(239,246,255,0.98) 0%, rgba(238,242,255,0.98) 100%)',
      // boxShadow:
      //   '0 10px 22px rgba(37, 99, 235, 0.14), 0 3px 8px rgba(37, 99, 235, 0.1), 0 0 0 1px rgba(191, 219, 254, 0.9) inset',
    },
    '& .MuiTab-root.Mui-selected $tabIcon': {
      color: '#2563eb',
      backgroundColor: 'rgba(37, 99, 235, 0.12)',
    },
    '& .MuiTab-root.Mui-selected $tabHint': {
      color: '#1d4ed8',
    },
    '& .MuiTab-root.Mui-selected $tabCount': {
      backgroundColor: '#2563eb',
      color: '#ffffff',
      boxShadow: '0 8px 18px rgba(37, 99, 235, 0.26)',
    },
    [theme.breakpoints.down('sm')]: {
      '& .MuiTab-root': {
        minWidth: 148,
      },
    },
  },
  title: {
    margin: theme.spacing(2),
    marginLeft: theme.spacing(2),
  },
  inputRoot: {
    backgroundColor: 'rgba(248, 250, 252, 0.9)',
    borderRadius: 8,
    paddingLeft: 8,
    transition: 'all 180ms ease',
    '& fieldset': {
      borderColor: 'rgba(148, 163, 184, 0.28)',
    },
    '&:hover fieldset': {
      borderColor: 'rgba(59, 130, 246, 0.4)',
    },
    '&$inputFocused': {
      backgroundColor: '#ffffff',
      boxShadow: '0 0 0 4px rgba(99,102,241,0.12)',
      '& fieldset': {
        borderColor: 'rgba(99,102,241,0.9)',
      },
    },
    // Handle browser autofill (Chrome)
    '& input:-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 1000px #ffffff inset',
      WebkitTextFillColor: '#0f172a',
      borderRadius: 8,
    },
    '& input:-webkit-autofill:focus': {
      WebkitBoxShadow: '0 0 0 1000px #ffffff inset',
      WebkitTextFillColor: '#0f172a',
    },
  },
  inputFocused: {},
}));

export default useStyles;
